import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ModalService } from '../../shared/services/modal.service';
import { empty } from '../../functions';
import { ModalAdminMeetdayComponent } from './modal-admin-meetday/modal-admin-meetday.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MeetDay } from '../../api/models/meet-day';
import { MeetDayService } from '../../api/services/meet-day.service';
import { FileDownloadService } from '../../shared/services/file-download.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-admin-meetdays',
    templateUrl: './admin-meetdays.component.html',
    styleUrls: ['./admin-meetdays.component.scss'],
    standalone: false
})
export class AdminMeetdaysComponent implements OnInit {

  public view = {

  };

  configTable = {
    hasPagination: true,
    columns: [

      {
        header_name: 'Name',
        name: 'name',
        type: 'text'
      },
      {
        header_name: 'Date',
        name: 'date',
        type: 'date'
      },
      {
        header_name: 'Street',
        name: 'address',
        subName: 'street',
        type: 'text'
      },
      {
        header_name: 'No.',
        name: 'address',
        subName: 'number',
        type: 'text'
      },
      {
        header_name: 'City',
        name: 'address',
        subName: 'city',
        type: 'text'
      },
      {
        header_name: 'Country',
        name: 'address',
        subName: 'country',
        type: 'text'
      },
    ],
    endpoint: 'meetday',
    data: <any>[],
    buttons: [
      {
        class: 'btn btn-danger',
        event: 'delete',
        text: 'Delete'
      },
      {
        class: 'btn btn-info',
        event: 'export',
        text: 'Export students'
      },
      {
        class: 'btn btn-warning',
        event: 'edit',
        text: 'Edit'
      }
    ],
    class: '',
    reloadListener: new Subject(),
    queryParams: null
  };

  constructor(
    public modal: ModalService,
    private meetDayService: MeetDayService,
    private fileDownloadService: FileDownloadService,
    private ngbModal: NgbModal,
  ) {}

  ngOnInit(): void {


  }

  addMeetday(): void {
    const entity: MeetDay = {
      id: undefined,
      date: '',
      name: '',
      address: {
        street: '',
        number: '',
        numberSuffix: undefined,
        postalCode: '',
        city: '',
        country: '',
      },
      registeredCompanies: undefined
    };

    this.openMeetdayDialog(entity);
  }

  private openMeetdayDialog(entity: MeetDay | any): void {
    const options: NgbModalOptions = {
      size: 'xl',
      backdrop: 'static',
      keyboard: false,
    };

    const modalRef = this.ngbModal.open(ModalAdminMeetdayComponent, options);
    modalRef.componentInstance.data = { entity };

    modalRef.result.then((result) => {
      if (result === true) {
        this.configTable.reloadListener.next(true);
      }
    }).catch(() => {
      // Modal dismissed
    });
  }

  /**
   * Update a meetday
   *
   * @param $data
   */
  updateMeetday($data: any) {
    // Load full profile first
    if (!empty($data['id'])) {
      this.meetDayService.getMeetDay({ id: $data['id'] }).subscribe((result) => {
        if (result) {
          this.openMeetdayDialog(result);
        }
      });
    }
  }

  /**
   * Handle button event of table
   *
   * @param $event
   */
  handleButtonEvent($event: any) {

    if (!empty($event['event'])) {

      switch ($event['event']) {

        case 'export':
          this.exportStudents($event['data']['id']);
          break;

        case 'edit':
          this.updateMeetday($event['data']);
          break;

        case 'delete':
          this.deleteMeetday($event['data']['id']);
          break;
      }
    }

  }

  /**
   * Delete the opened meet day
   *
   * @param id
   */
  deleteMeetday(id: string) {
    this.modal.Confirm('Delete', 'Are you sure you want to delete this?').then((confirm) => {
      if (confirm === true) {
        this.meetDayService.deleteMeetDay({ id }).subscribe(() => {
          // Reload data
          this.configTable.reloadListener.next(true);
        });
      }
    }).catch(() => {});
  }

  reloadData() {

    this.configTable.reloadListener.next(true);
  }

  resetFilters() {

    this.reloadData();
  }

  applyFilters()
  {
    this.reloadData();
  }

  exportStudents($id: any) {
    if (!$id) {
      return;
    }

    const endpoint = `meetday/${$id}/student/export`;
    const filename = `meetday-${$id}-students.xlsx`;
    this.fileDownloadService
      .downloadFromApiEndpoint(environment.apiUrl, endpoint, filename)
      .subscribe();
  }

}
